import Const from 'constants';
import Action from 'actions';

const ProjectionBoostRule = {
    setProjectionBoostRuleFromStorage(data) {
        return {
            type: Const.PROJECTION_BOOST_RULE_SET_DATA_FROM_STORAGE,
            data,
        };
    },

    useProjectionBoostRule(use) {
        return {
            type: Const.PROJECTION_BOOST_RULE_SET_IS_USED,
            use,
        };
    },

    addItemToProjectionBoostRule(item) {
        return (dispatch) => {
            dispatch({
                type: Const.PROJECTION_BOOST_RULE_ADD_ITEM,
                item,
            });

            dispatch(this.saveProjectionBoostRuleToStorage());
        };
    },

    removeItemOfProjectionBoostRule(itemId) {
        return (dispatch) => {
            dispatch({
                type: Const.PROJECTION_BOOST_RULE_REMOVE_ITEM,
                itemId,
            });

            dispatch(this.saveProjectionBoostRuleToStorage());
        };
    },

    saveProjectionBoostRuleToStorage() {
        return (dispatch) => {
            dispatch(
                this.saveDataToStorage('projectionBoostRule', function (state) {
                    const {projectionBoostRule} = state;

                    return projectionBoostRule.getDataToSaveInStorage();
                }),
            );
        };
    },
};

export default Object.assign(Action, ProjectionBoostRule);
